import { Component, Input, inject } from '@angular/core';
import { TabService } from '@services/tabs/TabService';
import { Pages } from '@constants/pages/Pages';
import { provideTranslocoScope } from '@jsverse/transloco';

@Component({
    selector: 'moi-processing-purpose-summary',
    templateUrl: './moi-processing-purpose-summary.component.html',
    styleUrls: ['./moi-processing-purpose-summary.component.scss'],
    standalone: false,
    providers: [provideTranslocoScope('moi')],
})
export class MoiProcessingPurposeSummaryComponent {
  private tabservice = inject(TabService);
  private pages = inject(Pages);

  @Input() summaryModel: any;
  @Input() processingPurposeID: any;

  openProcessingPurpose() {
      if (!this.processingPurposeID || !this.summaryModel.CanOpenParent) {
          return;
      }

      this.tabservice.generateTab(this.pages.DataManagement, this.processingPurposeID);
  }
}
